/**
 * Las 24 jurisdicciones argentinas (23 provincias + CABA), en MAYÚSCULAS y
 * con la grafía que va impresa en la tarjeta de licencia. Lista fija — no
 * cambia nunca, no hay endpoint: se usa tal cual para el campo "Provincia"
 * del alta de cliente (Superadmin) y queda disponible para cualquier otro
 * lugar que necesite validar/mostrar una provincia.
 *
 * Orden alfabético.
 */
export const PROVINCIAS_ARGENTINA = [
  'BUENOS AIRES',
  'CATAMARCA',
  'CHACO',
  'CHUBUT',
  'CIUDAD AUTÓNOMA DE BUENOS AIRES',
  'CÓRDOBA',
  'CORRIENTES',
  'ENTRE RÍOS',
  'FORMOSA',
  'JUJUY',
  'LA PAMPA',
  'LA RIOJA',
  'MENDOZA',
  'MISIONES',
  'NEUQUÉN',
  'RÍO NEGRO',
  'SALTA',
  'SAN JUAN',
  'SAN LUIS',
  'SANTA CRUZ',
  'SANTA FE',
  'SANTIAGO DEL ESTERO',
  'TIERRA DEL FUEGO',
  'TUCUMÁN',
];

// Normaliza para comparar sin importar acentos, mayúsculas ni espacios de
// más — así "cordoba", "Córdoba" y "CÓRDOBA " resuelven todos a la misma.
function normalizar(valor) {
  return String(valor || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/\s+/g, ' ')
    .trim();
}

const PROVINCIAS_POR_CLAVE = new Map(
  PROVINCIAS_ARGENTINA.map((p) => [normalizar(p), p])
);

/**
 * Si `valor` corresponde a una provincia de la lista (ignorando acentos,
 * mayúsculas y espacios), devuelve la forma canónica exacta (la que va en
 * la tarjeta). Si no matchea ninguna, devuelve null.
 */
export function resolverProvincia(valor) {
  return PROVINCIAS_POR_CLAVE.get(normalizar(valor)) || null;
}

/**
 * Provincias cuyo nombre contiene `texto` (para el autocompletado).
 * Con texto vacío devuelve la lista completa.
 */
export function filtrarProvincias(texto) {
  const clave = normalizar(texto);
  if (!clave) return PROVINCIAS_ARGENTINA;
  return PROVINCIAS_ARGENTINA.filter((p) => normalizar(p).includes(clave));
}
